/* =====================================================================
   COLDFRAME — 헤더 동작 (cf-header.js)
   카페24 pages/js/header.js + mo-header.js 를 jQuery 없이 옮긴 파일
   - 메인(첫 섹션이 투명 헤더 배너) : 상단에서 투명, 100px 이상 스크롤 시 흰색
   - 검색 오버레이, 국가/언어 상자, 모바일 메뉴(서브메뉴·언어 패널), 장바구니 개수
   ===================================================================== */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 100;

  function rafTwice(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  function initHeader(root) {
    if (!root || root.dataset.cfInit === '1') return;
    root.dataset.cfInit = '1';

    var header = root.querySelector('#header');
    if (!header) return;

    /* ---------------------------------------------------------------
       1) 투명 헤더(메인) / 스크롤
       --------------------------------------------------------------- */
    var firstSection = document.querySelector('#main > .shopify-section');
    var isMain = !!(firstSection && firstSection.querySelector('[data-cf-transparent-header]'));
    var searchOverlay = root.querySelector('#headerSearchOverlay');

    if (isMain) {
      header.classList.add('is-main');
    } else {
      header.classList.add('active');
      header.classList.remove('is-main');
    }

    function handleScroll() {
      if (!isMain) return;
      if (window.scrollY > SCROLL_THRESHOLD) {
        header.classList.add('active');
      } else if (!searchOverlay || !searchOverlay.classList.contains('active')) {
        header.classList.remove('active');
      }
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    /* ---------------------------------------------------------------
       2) 검색 오버레이
       --------------------------------------------------------------- */
    var searchDimmed = root.querySelector('#headerSearchOverlayDimmed');
    var searchMoBox = root.querySelector('#headerSearchMoBox');
    var searchForm = searchOverlay ? searchOverlay.querySelector('form') : null;

    function focusSearchInput() {
      var input = searchForm ? searchForm.querySelector('#keyword') : null;
      if (input) input.focus();
    }

    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.add('active');
      if (searchDimmed) searchDimmed.classList.add('is-open');
      if (isMain) header.classList.add('active');
      rafTwice(focusSearchInput);
    }

    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.remove('active');
      if (searchDimmed) searchDimmed.classList.remove('is-open');
      if (isMain && window.scrollY <= SCROLL_THRESHOLD) header.classList.remove('active');
    }

    root.querySelectorAll('.header-search-btn').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (searchOverlay && searchOverlay.classList.contains('active')) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    });

    if (searchDimmed) searchDimmed.addEventListener('click', closeSearch);

    root.addEventListener('click', function (event) {
      var cancel = event.target.closest('.header-search-cancel');
      if (!cancel || !root.contains(cancel)) return;

      var mobileSection = cancel.closest('.search-section');
      if (!mobileSection) {
        closeSearch();
      } else {
        mobileSection.classList.remove('active');
        if (searchForm && searchOverlay) searchOverlay.appendChild(searchForm);
      }
    });

    root.addEventListener('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.classList && event.target.classList.contains('header-search-cancel')) {
        event.preventDefault();
        event.target.click();
      }
    });

    if (searchMoBox) {
      root.querySelectorAll('.menu-footer .header-search-mobtn').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var section = btn.closest('.search-section');
          if (searchForm) searchMoBox.appendChild(searchForm);
          if (section) section.classList.add('active');
          setTimeout(focusSearchInput, 50);
        });
      });
    }

    /* ---------------------------------------------------------------
       3) 국가/언어 선택 상자
       --------------------------------------------------------------- */
    var langBox = root.querySelector('.lang-selector');
    var langBtn = root.querySelector('#header .header-langsel-btn');

    if (langBox && langBtn) {
      langBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var open = langBox.classList.toggle('open');
        langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      var langClose = langBox.querySelector('.lang-selector__close');
      if (langClose) {
        langClose.addEventListener('click', function () {
          langBox.classList.remove('open');
          langBtn.setAttribute('aria-expanded', 'false');
        });
      }
    }

    /* ---------------------------------------------------------------
       4) 모바일 메뉴
       --------------------------------------------------------------- */
    var hamburger = root.querySelector('#hamburgerBtn');
    var mobileMenu = root.querySelector('#mobileMenu');
    var menuOverlay = root.querySelector('#menuOverlay');
    var mainNav = root.querySelector('#mainNav');
    var languagePanel = root.querySelector('#languagePanel');

    function resetToMainMenu() {
      if (!mobileMenu) return;
      mobileMenu.querySelectorAll('.submenu').forEach(function (submenu) {
        submenu.classList.remove('active');
        setTimeout(function () {
          if (!submenu.classList.contains('active')) submenu.style.display = 'none';
        }, 300);
      });
      setTimeout(function () {
        if (mainNav) mainNav.classList.remove('hidden');
      }, 150);
    }

    function openMenu() {
      if (!mobileMenu) return;
      var topValue = header.clientHeight + header.getBoundingClientRect().top;
      mobileMenu.style.setProperty('--cf-mobile-menu-top', (topValue + 1) + 'px');
      if (menuOverlay) menuOverlay.style.top = (topValue - 2) + 'px';

      mobileMenu.classList.add('active');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (menuOverlay) menuOverlay.classList.add('active');
      document.body.classList.add('mo-menu-opened');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      resetToMainMenu();
    }

    function closeMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('active');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (menuOverlay) menuOverlay.classList.remove('active');
      document.body.classList.remove('mo-menu-opened');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      resetToMainMenu();
    }

    function closeLanguagePanel() {
      if (!languagePanel) return;
      languagePanel.classList.remove('active');
      if (mobileMenu) mobileMenu.classList.remove('language-panel-open');
    }

    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function () {
        if (mobileMenu.classList.contains('active')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      var closeBtn = mobileMenu.querySelector('.mo-header-close-btn');
      if (closeBtn) closeBtn.addEventListener('click', closeMenu);
      if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

      mobileMenu.querySelectorAll('.menu-item[data-submenu]').forEach(function (item) {
        item.addEventListener('click', function (event) {
          event.preventDefault();
          var submenu = mobileMenu.querySelector('#' + item.getAttribute('data-submenu'));
          if (!submenu) return;
          if (mainNav) mainNav.classList.add('hidden');
          submenu.style.display = 'flex';
          rafTwice(function () {
            submenu.classList.add('active');
          });
        });
      });

      mobileMenu.querySelectorAll('.back-btn').forEach(function (btn) {
        btn.addEventListener('click', resetToMainMenu);
      });

      var languageToggle = mobileMenu.querySelector('#languageToggleBtn');
      if (languageToggle && languagePanel) {
        languageToggle.addEventListener('click', function (event) {
          event.preventDefault();
          languagePanel.classList.add('active');
          mobileMenu.classList.add('language-panel-open');
        });
      }

      var languageClose = mobileMenu.querySelector('#languageCloseBtn');
      if (languageClose) languageClose.addEventListener('click', closeLanguagePanel);

      // 화면이 PC 폭으로 바뀌면 모바일 메뉴 닫기
      var desktopMql = window.matchMedia('(min-width: 1025px)');
      var onDesktopChange = function (mql) {
        if (mql.matches && mobileMenu.classList.contains('active')) closeMenu();
      };
      if (desktopMql.addEventListener) {
        desktopMql.addEventListener('change', onDesktopChange);
      }
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (languagePanel && languagePanel.classList.contains('active')) {
        closeLanguagePanel();
        return;
      }
      if (mobileMenu && mobileMenu.classList.contains('active')) closeMenu();
      if (searchOverlay && searchOverlay.classList.contains('active')) closeSearch();
      if (langBox && langBox.classList.contains('open')) langBox.classList.remove('open');
    });

    /* ---------------------------------------------------------------
       5) 장바구니 개수
       --------------------------------------------------------------- */
    function renderCount(count) {
      root.querySelectorAll('[data-cf-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
      root.querySelectorAll('[data-cf-cart-count-wrap]').forEach(function (el) {
        el.classList.toggle('displaynone', !(count > 0));
      });
    }

    function refreshCount() {
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) { renderCount(cart.item_count); })
        .catch(function () {});
    }

    document.addEventListener('cart:change', function (event) {
      if (event.detail && event.detail.cart && typeof event.detail.cart.item_count === 'number') {
        renderCount(event.detail.cart.item_count);
      } else {
        refreshCount();
      }
    });
    document.addEventListener('cart:refresh', refreshCount);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshCount();
    });
  }

  function initTopBanner(root) {
    if (!root || root.dataset.cfInit === '1') return;
    root.dataset.cfInit = '1';

    var wrap = root.querySelector('.top-banner-wrap.is-rotating');
    if (!wrap) return;
    var items = wrap.querySelectorAll('.top-banner-item');
    if (items.length < 2) return;

    var speed = Math.max(parseInt(wrap.dataset.speed || '5', 10), 2) * 1000;
    var index = 0;
    setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, speed);
  }

  function initAll() {
    document.querySelectorAll('[data-cf-header]').forEach(initHeader);
    document.querySelectorAll('[data-cf-top-banner]').forEach(initTopBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // 테마 편집기에서 섹션을 다시 그릴 때
  document.addEventListener('shopify:section:load', initAll);
})();

/* PC 상단 메뉴: 링크가 '#'(빈 링크)인 메뉴(JEWELRY·GIFT)는 눌러도 이동하지 않고 하위 메뉴만 열림 */
document.addEventListener('click', function (event) { var title = event.target.closest ? event.target.closest('.pc-menu-item-new > .pc-menu-title') : null; if (title && (title.getAttribute('href') || '').slice(-1) === '#') event.preventDefault(); });
